import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=34e998ac&scoped=true&"
import script from "./TopBar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e998ac",
  null
  
)

export default component.exports